export const INITIATIVES_SIDEBAR_LABELS = {
	CREATED_BY: 'Created By',
	OWNED_BY: 'Owned By',
	TAGS: 'Tags'
};
